export const ACCOUNTS_PAYABLE_QUEUE_TYPES = {
  AWAITING_ACTION: "awaiting_action",
  ON_HOLD: "on_hold",
  AWAITING_SAP_EXPORT: "awaiting_sap_export",
  AWAITING_SAP_IMPORT: "awaiting_sap_import",
  ON_USER_HOLD: "on_user_hold",
  HISTORICAL: "historical",
  SEARCH: "search",
};
